/**
 * Google Tag Manager (Google Analytics) integration.
 * Migrated from common/TagManager/TagManager.tsx. Active only in production.
 * Guards on `window` so it is a no-op during SSG prerendering.
 */
import { ENV, isProduction } from "./env"

const GTM_ID = ENV.GTM_ID || "GTM-N6WCQ8H"

interface DataLayerWindow extends Window {
	dataLayer?: Array<Record<string, unknown>>
}

let initialized = false

export function initGtm(): void {
	if (typeof window === "undefined" || !isProduction() || initialized) return
	initialized = true

	const w = window as DataLayerWindow
	w.dataLayer = w.dataLayer || []
	w.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" })

	const script = document.createElement("script")
	script.async = true
	script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
	document.head.appendChild(script)
}

export function trackPageView(path: string): void {
	if (typeof window === "undefined" || !isProduction()) return
	const w = window as DataLayerWindow
	w.dataLayer = w.dataLayer || []
	w.dataLayer.push({ event: "page_view", page_path: path })
}
